module.exports = __webpack_public_path__ + "static/media/service16.613ff043.jpg";